import React, { createContext, useState, useContext, useRef, useEffect } from 'react';

const OvenContext = createContext();

const PRODUCTS = [
  { id: 1, name: 'Pizza Margherita', icon: '🍕', category: 'pizza', video: '', gif: 'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNDZyYXhldmJ3aTB6Y3pibDF2b2Fpa2N5ZDBkeGZ3cHJ3N3NjbmJvOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9dg/v7VDS5pnEggs3kqhnl/giphy.gif', bakingTime: 4000 },
  { id: 2, name: 'Brownie Supreme', icon: '🍫', category: 'brownie', video: 'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMHVydnFrbTJhMm1wNXB6OWt4YjAwbm9nYWpreGkwZ2Y0OWtnbzBhYiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9dg/CigKrm7Gabeeda8TxB/giphy.gif', gif: 'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExdTJhMW9yZmlsd3picGF1eTM2bXRjcXEyMTdqOXNkNjc2MnNwaDdiMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gIqguY2jmB31LZqWip/giphy.gif', bakingTime: 5000 },
  { id: 3, name: 'Galleta Crisp', icon: '🍪', category: 'galleta', video: 'https://www.w3schools.com/html/mov_bbb.mp4', gif: 'https://media.giphy.com/media/3o6Zt5KzGKbUYWmUMU/giphy.gif', bakingTime: 3500 },
  { id: 4, name: 'Pan Artesanal', icon: '🥖', category: 'pan', video: 'https://www.w3schools.com/html/mov_bbb.mp4', gif: 'https://media.giphy.com/media/l0IylOPCNkiqOgMyA/giphy.gif', bakingTime: 6000 },
  { id: 5, name: 'Croissant', icon: '🥐', category: 'croissant', video: 'https://www.w3schools.com/html/mov_bbb.mp4', gif: 'https://media.giphy.com/media/3o6Zt6qW2lFfYMV2kI/giphy.gif', bakingTime: 4500 }
];

export const OvenProvider = ({ children }) => {
  const [currentProduct, setCurrentProduct] = useState('pizza');
  const [isBaking, setIsBaking] = useState(false);
  const [productReady, setProductReady] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const timeoutRef = useRef(null);

  const getProduct = (type) => {
    return PRODUCTS.find(p => p.category === type);
  };

  const startBaking = (productType) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const product = getProduct(productType);
    if (!product) return;

    setIsBaking(true);
    setProductReady(false);
    setShowGif(false);
    setCurrentProduct(productType);

    timeoutRef.current = setTimeout(() => {
      setIsBaking(false);
      setProductReady(true);
      setShowGif(true);
    }, product.bakingTime);
  };

  const resetOven = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsBaking(false);
    setProductReady(false);
    setShowGif(false);
  };

  useEffect(() => {
    startBaking('pizza');
    return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); };
  }, []);

  return (
    <OvenContext.Provider value={{
      PRODUCTS,
      currentProduct,
      isBaking,
      productReady,
      showGif,
      getProduct,
      startBaking,
      resetOven
    }}>
      {children}
    </OvenContext.Provider>
  );
};

export const useOven = () => useContext(OvenContext);
